/**
 * @file:  图片
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/02      1.0     First version
 *
 * @param src 图片链接
 * @param alt
 * @param width 图片宽度
 * @param 样式名
 * @param 失效，失效无放大效果
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import {Popover} from "antd";
import LazyLoad from "react-lazyload";
const Image = ({src,alt,title,width=80,className="",isInvalid=false}) => {
    const srcList = src?src.split("@"):[];
    src = srcList&&srcList.length>0?srcList[0]:src;
        return (isInvalid?<img src={src?src+'@!200':'/assets/img/default/nbsp-sm.jpg'} alt={alt} title={title} width={width} className={className}/>:<Popover placement="right" trigger="hover" arrowPointAtCenter={true} content={
                    <img src={src+'@!400'} style={{width:'400px',height:'400px'}} alt={alt}/>
            }><span>
                    <LazyLoad
                        once={true}
                        height={width}
                        placeholder={<img src={"/assets/img/default/nbsp-sm.jpg"} />}
                        offset={0}>
                        <img src={src+'@!200'} alt={alt} title={title} width={width} className={className}/>
                    </LazyLoad>
            </span>
            </Popover>);
}

export default Image;
